interface INoItem {
    title?: string;
    desc?: string
}

const NoItem = ({ title, desc }: INoItem) => {
    return (
        <div className='w-full min-h-[500px] bg-surface border border-edge rounded-2xl py-[50px] flex items-start justify-center animate-fade-in smallTablet:min-h-[280px] smallTablet:py-6 smallTablet:px-4'>
            <div className='my-10 text-center'>
                <h2 className='text-md font-heading-font my-1 bg-gradient-heading bg-clip-text text-transparent'>{title ? title : "Chase List Empty 🎉"}</h2>
                <p className='text-text-secondary text-[.9rem] font-[600]'>{desc ? desc : "There is nothing to chase 🥳"}</p>
            </div>
        </div>
    )
}

export default NoItem
